import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useRemoveKegiatanSosial } from "../../../../api/effects/mutations/KegiatanSosial/removeKegiatanSosial";
import { RemoveModal } from "../../../../components/RemoveModal";
import { KegiatanSosialResponse } from "../../../../models/KegiatanSosial";
import { convertDate } from "../../../../utils/dateConvert";
import KegiatanSosialModal from "./KegiatanSosialModal";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

type Props = {
  data: KegiatanSosialResponse[];
};

export default function KegiatanSosialTable({ data }: Props) {
  const [editId, setEditId] = useState<number | null>(null);
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [removeModalText, setRemoveModalText] = useState("");

  const handleOpenRemoveModal = (text: string, id: number) => {
    setDeletingId(id);
    setRemoveModalText(`Remove ${text}?`);
  };

  const handleCloseRemoveModal = () => {
    setDeletingId(null);
  };

  const handleOpenEditModal = (id: number) => {
    setEditId(id);
  };

  const handleCloseEditModal = () => {
    setEditId(null);
  };

  const { mutateAsync: RemoveKegiatanSosial } = useRemoveKegiatanSosial({
    onSuccess() {
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const handleRemove = () => {
    if (deletingId !== null) {
      RemoveKegiatanSosial(deletingId);
      handleCloseRemoveModal();
    }
  };

  return (
    <Grid container justifyContent="center">
      <KegiatanSosialModal
        open={!!editId}
        handleClose={handleCloseEditModal}
        ID={editId || undefined}
      />
      <RemoveModal
        open={!!deletingId}
        handleClose={handleCloseRemoveModal}
        handleRemove={handleRemove}
        text={removeModalText}
      />
      <SquareGrid container>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Action</TableCell>
                <TableCell>Organisasi </TableCell>
                <TableCell>Kegiatan</TableCell>
                <TableCell>Jabatan</TableCell>
                <TableCell>Tahun</TableCell>
                <TableCell align="center">Hapus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => (
                <TableRow
                  key={row.KEGIATAN_SOSIAL_ID}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Button
                      onClick={() =>
                        handleOpenEditModal(row.KEGIATAN_SOSIAL_ID)
                      }
                      disabled={!!deletingId || !!editId}
                    >
                      Ubah
                    </Button>
                  </TableCell>
                  <TableCell>{row.ORGINASASI}</TableCell>
                  <TableCell>{row.KEGIATAN}</TableCell>
                  <TableCell>{row.JABATAN}</TableCell>
                  <TableCell>{convertDate(row.TAHUN)}</TableCell>
                  <TableCell align="center">
                    <Button
                      color="error"
                      onClick={() =>
                        handleOpenRemoveModal(
                          `${row.KEGIATAN}`,
                          row.KEGIATAN_SOSIAL_ID
                        )
                      }
                      disabled={!!deletingId || !!editId}
                    >
                      Hapus
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SquareGrid>
    </Grid>
  );
}